import React from "react";
import styled from "styled-components";
import { DialogActions, DialogTitle, DialogContent, Icon } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { BeautifulDialog, ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { getStaticUrl } from "js/config";
import { defaultText } from "js/textStyles";
import ChangePlanDialog from "js/react/components/Dialogs/ChangePlanDialog";
import { WorkspacePlanTier } from "common/interfaces";
import { Button as BeautifulButton } from "js/Components/Button";
import { themeColors } from "js/react/sharedStyles";
import { FlexBox } from "js/react/components/LayoutGrid";

const StyledDialogTitle = styled(DialogTitle)`
    &.MuiDialogTitle-root {
        padding: 40px 50px 5px 50px;
    }

    h2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }
`;

const StyledDialogContent = styled(DialogContent)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding: 0px;
    ${defaultText}
`;

const StyledDialogActions = styled(DialogActions)`
    &.MuiDialogActions-root {
        justify-content: end;
        padding: 30px 50px 40px 50px;
        margin: 0px;
    }
`;

const FeatureContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 15px;
    gap: 15px;
    margin: 0 50px;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    border: 1px solid  #DAE9F0;
    background: #F7FAFC;
    color: #333;
`;

const StyledUpgradeButton = styled(BeautifulButton)`
    &&& {
        padding: 6px 20px;
    }
`;

export const UpgradeToTeamPlanDialog = ({ closeDialog }: { closeDialog: () => void }) => {
    const { t } = useTranslation();

    return (
        <BeautifulDialog closeDialog={closeDialog}>
            <StyledDialogTitle>
                <img src={getStaticUrl("/images/beautifulai-logos/beautifulai-upgrade-logo.svg")} />
                <div>{t("Upgrade to unlock team folders")}</div>
            </StyledDialogTitle>
            <StyledDialogContent>
                <div style={{ textAlign: "center", maxWidth: 400 }}>
                    {t("Upgrade to our Team plan to collaborate seamlessly and keep your team’s presentations organized and easy to find.")}
                </div>
                <FeatureContainer>
                    <FlexBox gap={8} horizontalAlign="left">
                        <Icon style={{ color: "#FFAA00" }} fontSize="small">check_circle</Icon>
                        <div>{t("Branded Team Themes")}</div>
                    </FlexBox>
                    <FlexBox gap={8} horizontalAlign="left">
                        <Icon style={{ color: "#FFAA00" }} fontSize="small">check_circle</Icon>
                        <div>{t("Dynamic Shared Slides and Slide Templates")}</div>
                    </FlexBox>
                    <FlexBox gap={8} horizontalAlign="left">
                        <Icon style={{ color: "#FFAA00" }} fontSize="small">check_circle</Icon>
                        <div>{t("Custom Presentation Templates")}</div>
                    </FlexBox>
                    <FlexBox gap={8} horizontalAlign="left">
                        <Icon style={{ color: "#FFAA00" }} fontSize="small">check_circle</Icon>
                        <div>{t("Brand Guardrails")}</div>
                    </FlexBox>
                </FeatureContainer>
            </StyledDialogContent>

            <StyledDialogActions>
                <BeautifulButton unframed large color={themeColors.mediumGray} onClick={closeDialog}>
                    {t("Cancel")}
                </BeautifulButton>
                <StyledUpgradeButton upgrade onClick={() => {
                    closeDialog();
                    ShowDialog(ChangePlanDialog, { featuredPlan: WorkspacePlanTier.TEAM });
                }}>
                    {t("Upgrade")}
                </StyledUpgradeButton>
            </StyledDialogActions>
        </BeautifulDialog>
    );
};
